import { useState, useEffect, useCallback } from 'react'
import { useAuth } from '@/modules/auth/hooks/useAuth'
import { RoutesApi, RouteResponse, GetRoutesQueryDto } from '@/shared/api/routes'

export function useRoutes() {
  const { getToken } = useAuth()
  const [routes, setRoutes] = useState<RouteResponse[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const routesApi = useCallback(() => new RoutesApi(getToken), [getToken])

  /**
   * @deprecated Routes are now drawn client-side, not fetched from backend
   */
  const fetchRoutes = useCallback(async (query?: GetRoutesQueryDto) => {
    setRoutes([])
  }, [])

  return {
    routes,
    loading,
    error,
    fetchRoutes
  }
}
